import React from "react";
import BackgroundImage from "../../../../assets/KeyFeatures_BackgroundColor.png"; // Adjust the path to your image

const PricingPlan = () => {
  return (
    <div
      className="py-20 px-4 sm:space-y-0 sm:mb-28"
    // style={{
    // backgroundImage: `url(${BackgroundImage})`,  // Apply the background image directly
    //   backgroundSize: "cover",  // Ensure the background image covers the section
    //   backgroundPosition: "center",  // Center the image
    //   backgroundAttachment: "fixed",  // Fixed attachment for the floating effect
    // }}
    >
      {/* <div className="text-center text-white mb-4 sm:w-[360px] md:w-[650px] lg-xl:w-[800px] xl-2xl:w-[1200px] sm:p-[12px] md:p-[15px] xl-2xl:p-[20px] md:ml-[40px] md-xl:ml-[60px] lg-xl:ml-[90px] xl-2xl:ml-[120px]"> */}
      <div className="text-center text-black w-auto mb-4 ">
        <h1
          className="font-semibold mb-2 text-[24px] md:text-[32px] lg-xl:text-[40px] xl-2xl:text-[48px]"
          style={{
            fontFamily: "Lexend, sans-serif",
            fontWeight: 600,
            // fontSize: "48px",
            letterSpacing: "-3%",
            textTransform: "lowercase",
            lineHeight: "100%",
          }}
        >
          Serve More, Spend Less -
        </h1>
        <h2
          className="text-2xl font-semibold mb-8 text-[24px] md:text-[32px] lg-xl:text-[40px] xl-2xl:text-[48px]"
          style={{
            fontFamily: "Lexend, sans-serif",
            fontWeight: 600,
            // fontSize: "48px",
            letterSpacing: "-3%",
            textAlign: "center",
            textTransform: "lowercase",
            lineHeight: "100%",
            color: "#FFAD00",
          }}
        >
          With Chat Ordering That Works For You
        </h2>
        <p className="text-[16px] sm:text-[14px] xl-2xl:text-[20px] sm:max-w-[360px] md:max-w-[690px] md-xl:max-w-[720px] lg-xl:max-w-[1000px] xl-2xl:max-w-[1290px] mx-auto lowercase leading-[1.4rem] tracking-[0.05rem] sm:mt-[-1rem] md:mt-[-1.2rem] font-lexend font-normal font-semibold">
          Every order costs time and money. Traditional waiters can only take
          one table at a time - writing, walking, re-entering, and relaying
          orders to the kitchen.
          <span class="font-lexend font-bold text-[16px] sm:text-[14px] xl-2xl:text-[20px] leading-[26px] tracking-[0px] text-center lowercase">
            {" "} beɘmz {" "}
          </span>
          replaces that with instant,
          unlimited chat-based ordering and kitchen relay - at a fraction of the
          cost.
        </p>
      </div>

      {/* New div with purple background for the table */}
      {/* <div className="bg-[#FFFFFF33] py-10 px-10 rounded-[15px] shadow-lg mb-12 sm:w-[500px] xl-2xl:w-[1430px] h-[850px] md:m-[20px] lg-xl:m-[26px] xl-2xl:m-[32px]">
        <table className="min-w-full table-auto text-sm text-left text-white overflow-x-auto"> */}
      {/* <div className="w-full justify-center overflow-x-auto bg-[#FFFFFF33] rounded-[15px] w-[800px] md:w-[685px] md-xl:w-[735px] lg-xl:w-[940px] xl-2xl:w-[1435px] sm:ml-[10px] md:ml-[25px] lg-xl:ml-[27px] xl-2xl:ml-[30px]"> */}
      {/* <div className="w-full flex justify-center items-center overflow-x-auto bg-[#FFFFFF33] rounded-[15px] xl-2xl:w-[1435px] sm:ml-[10px] md:ml-[25px] lg-xl:ml-[27px] xl-2xl:ml-[30px] sm:mr-[10px] md:mr-[25px] lg-xl:mr-[27px] xl-2xl:mr-[30px]"> */}

      <div className="w-full overflow-x-auto rounded-[22px] bg-[#FFFFFF1F] px-6 py-6 sm:px-8 sm:py-8 md:px-10 md:py-10 my-20 sm:my-24 md:my-4 lg:my-4 overflow-auto scrollbar-hide ">
        {/* <table className="table-auto sm:text-[14px] text-left text-white sm:w-[500px] md:w-[620px] md-xl:w-[675px] lg-xl:w-[880px] xl-2xl:w-[1350px]m-[20px] sm:m-[20px] md:m-[24px] md-xl:m-[30px] xl-2xl:m-[40px] lg-xl:m-[30px]"> */}
        {/* <table className="table-auto w-auto sm:text-[14px] text-center text-white sm:max-w-[600px] m-[20px] sm:m-[20px] md:m-[20px] md-xl:m-[30px] xl-2xl:m-[40px] lg-xl:m-[30px] sm:ml-[350px]"> */}
        <div className="w-full sm:min-w-[380px] sm-xl:min-w-[480px] min-w-[910px] overflow-x-auto rounded-tl-[26px] rounded-tr-[24px] border border-black px-0 overflow-auto scrollbar-hide sm:m-[-1.5rem] sm-xl:m-[-1.2rem] sm:mb-[-.5rem]">
          <table className="w-full sm:min-w-[370px] sm-xl:min-w-[470px] min-w-[900px] text-center text-[20px] sm:text-[10px] border-collapse overflow-hidden rounded-tl-[22px] rounded-tr-[22px] rounded-bl-none rounded-br-none">
            <thead>
              <tr className="text-white lowercase">
                {/* Blue background for "Function" */}
                <th className="sm:px-1 sm:py-1 px-6 py-3 bg-[#3CAA8C] text-white font-bold text-center  border-b border-black rounded-tl-[22px]">Function</th>
                {/* Orange background for "Traditional Waiter" */}
                <th className="sm:px-0 sm:py-1 px-6 py-3  bg-[#D8922A] text-white font-bold text-center border-l  border-b border-black" colSpan={3}>Traditional Waiter</th>
                {/* Purple background for "Beemz" */}
                <th className="sm:px-2 sm:py-1 px-6 py-3  bg-[#8C39BE] text-white font-bold text-center border-l border-b border-black rounded-tr-[22px]">beɘmz</th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                {/* Column headers */}
                <th className="sm:px-1 sm:py-1 px-6 py-3 border-solid border-black  border-r border-b"></th>
                <th className="sm:px-0 sm:py-1 px-6 py-3 border-solid border-black border-r border-b ">South Africa</th>
                <th className="sm:px-0 sm:py-1 px-6 py-3 border-solid border-black border-r border-b ">India</th>
                <th className="sm:px-0 sm:py-1 px-6 py-3 border-solid border-black border-r border-b">Indonesia</th>
                <th className="sm:px-2 sm:py-1 px-6 py-3 border-solid border-black  border-b"></th>
                {/* <th className="px-6 py-3 border-solid border-white border-b">Beemz</th> */}
              </tr>
            </thead>
            <tbody className="text-black lowercase font-semibold">
              <tr className="border-b border-black">
                <td className="sm:px-1 sm:py-1 px-6 py-4 font-semibold border-r border-black">Monthly Cost</td>
                <td className="sm:px-0 sm:py-1 px-6 py-4 border-l border-r border-black">R2,247 - R4,051 ($131 - $236)</td>
                <td className="sm:px-0 sm:py-1 px-6 py-4 border-l border-r border-black">₹11,830 - ₹29,302 ($142 - $353)</td>
                <td className="sm:px-0 sm:py-1 px-6 py-4 border-l border-r border-black">Rp1,953,000 - Rp11,273,000 ($142 - $353)</td>
                <td className="sm:px-2 sm:py-1 px-6 py-4 border-l  border-black">$30</td>
              </tr>
                <tr className="border-b border-black">
                <td className="sm:px-1 sm:py-1 px-6 py-4 font-semibold border-r border-black">Orders Handled</td>
                <td className="sm:px-0 sm:py-1 px-6 py-4 border-l border-r border-black">1,000 - 4,000</td>
                <td className="sm:px-0 sm:py-1 px-6 py-4 border-l border-r border-black">1,000 - ₹4,000</td>
                <td className="sm:px-0 sm:py-1 px-6 py-4 border-l border-r border-black">1,000 - 4,000</td>
                <td className="sm:px-2 sm:py-1 px-6 py-4 border-l border-black">Unlimited</td>
              </tr>
             <tr className="border-b border-black">
                <td className="sm:px-1 sm:py-1 px-6 py-4 font-semibold  border-r border-black">Cost per Order</td>
                <td className="sm:px-0 sm:py-1 px-6 py-4 border-l border-r border-black">R1,2 ($0.07)</td>
                <td className="sm:px-0 sm:py-1 px-6 py-4 border-l border-r border-black">₹7.3 ($0,09)</td>
                <td className="sm:px-0 sm:py-1 px-6 py-4 border-l border-r border-black">Rp2 666,67 ($0.16)</td>
                <td className="sm:px-2 sm:py-1 px-6 py-4 border-l border-black">&lt; $0.01 (nearly zero)</td>
              </tr>
              <tr className="border-b border-black">
                <td className="sm:px-1 sm:py-1 px-6 py-4 font-semibold  border-r border-black">Errors & Miscommunication</td>
                <td className="sm:px-0 sm:py-1 px-6 py-4 border-l border-r border-black">Frequent</td>
                <td className="sm:px-0 sm:py-1 px-6 py-4 border-l border-r border-black">Frequent</td>
                <td className="sm:px-0 sm:py-1 px-6 py-4 border-l border-r border-black">Frequent</td>
                <td className="sm:px-2 sm:py-1 px-6 py-4 border-l  border-black">Eliminated</td>
              </tr>
              <tr className="border-b border-black">
                <td className="sm:px-1 sm:py-1 px-6 py-4 font-semibold  border-r border-black">Peak-Time Performance</td>
                <td className="sm:px-0 sm:py-1 px-6 py-4 border-l border-r border-black">Limited by staff</td>
                <td className="sm:px-0 sm:py-1 px-6 py-4 border-l border-r border-black">Limited by staff</td>
                <td className="sm:px-0 sm:py-1 px-6 py-4 border-l border-r border-black">Limited by staff</td>
                <td className="sm:px-2 sm:py-1 px-6 py-4 border-l  border-black">Instant and Scalable</td>
              </tr>
              <tr className="border-b border-black">
                <td className="sm:px-1 sm:py-1 px-6 py-4 font-semibold border-r border-black">Take Order</td>
                <td className="sm:px-0 sm:py-1 px-6 py-4 border-l border-r border-black">3-8 min</td>
                <td className="sm:px-0 sm:py-1 px-6 py-4 border-l border-r border-black">3-8 min</td>
                <td className="sm:px-0 sm:py-1 px-6 py-4 border-l border-r border-black">3-8 min</td>
                <td className="sm:px-2 sm:py-1 px-6 py-4 border-l border-black">Instant via chat</td>
              </tr>
              <tr className="border-b border-black">
                <td className="sm:px-1 sm:py-1 px-6 py-4 font-semibold  border-r border-black">Relay to Kitchen</td>
                <td className="sm:px-0 sm:py-1 px-6 py-4 border-l border-r border-black">1-2 min</td>
                <td className="sm:px-0 sm:py-1 px-6 py-4 border-l border-r border-black">1-2 min</td>
                <td className="sm:px-0 sm:py-1 px-6 py-4 border-l border-r border-black">1-2 min</td>
                <td className="sm:px-2 sm:py-1 px-6 py-4 border-l border-black">Automatic</td>
              </tr>
              <tr className=" border-black">
                <td className="sm:px-1 sm:py-1 px-6 py-4 font-semibold  border-r border-black">Total per Order</td>
                <td className="sm:px-0 sm:py-1 px-6 py-4 border-l border-r border-black">5-10 min</td>
                <td className="sm:px-0 sm:py-1 px-6 py-4 border-l border-r border-black">5-10 min</td>
                <td className="sm:px-0 sm:py-1 px-6 py-4 border-l border-r border-black">5-10 min</td>
                <td className="sm:px-2 sm:py-1 px-6 py-4 border-l  border-black">&lt; 10 Seconds</td>
              </tr> 
              {/* <tr className="border-b border-black">
              <td className="px-6 py-4 font-semibold border-l border-r border-black">Total Savings 100 Orders/Day</td>
              <td className="px-6 py-4 border-l border-r border-black">R75 - R135</td>
              <td className="px-6 py-4 border-l border-r border-black">₹394 - ₹797</td>
              <td className="px-6 py-4 border-l border-r border-black">Rp65100 - Rp375767</td>
              <td className="px-6 py-4 border-l border-r border-black">Subscription</td>
            </tr> */}
            </tbody>
          </table>
        </div>
      </div>

      <div
        className="
    text-black
    text-sm                /* mobile */
    sm:text-base           /* tablet */
    md:text-lg             /* laptop */
    leading-relaxed
    sm:leading-normal
    md:leading-snug
    text-left
    px-2 sm:px-6 md:px-10  /* responsive padding */
    font-lexend font-medium text-[18px] leading-[26px] tracking-normal lowercase
    tracking-[0.09]
    mt-[20px]
  "
      >
        ⦁ A small restaurant doing ~100 orders/day can save 6–10 labor hours($142 pm),
        increase daily revenue significantly, and earn 3–5% more revenue monthly.
      </div>

    </div>
  );
};

export default PricingPlan;
